export function getStockFromShoppingReq (materialId, cart) {
  const item = cart.shoppingRequest.cart.cartItems.filter(
    (item) => item.materialInfo.materialId === materialId
  )[0]

  if (item?.materialInfo.nonShipabble) {
    return Infinity
  }

  return item?.stock
}
